/**
 * @fileoverview Project data source and type definitions.
 */

import { ProjectSchema, type Project } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createAccountTrackingFields, createArchivedAtField, createCreatedAtField, createDateField, createDeletedAtField, createIdField, createJsonField, createNameField, createNumberField, createSelectField, createStringField, createUpdatedAtField, FIELD_TYPE_WIDTHS, FIELD_WIDTHS } from './field-factories';
import { getCache } from './cache-registry';

export type { Project };

/** Priority options for project dropdown. */
const PRIORITY_OPTIONS = [
  { value: 'Very Low', label: 'Very Low' },
  { value: 'Low', label: 'Low' },
  { value: 'Medium', label: 'Medium' },
  { value: 'High', label: 'High' },
  { value: 'Very High', label: 'Very High' },
  { value: 'Critical', label: 'Critical' },
] as const;

export const projectDataSource = createBaseDataSource<Project>({
  endpoint: 'project',
  searchField: 'name',
  schema: ProjectSchema,
  fields: [
    createIdField(FIELD_WIDTHS.SMALL),
    createNameField(FIELD_TYPE_WIDTHS.NAME),
    createStringField('description', 'Description', FIELD_WIDTHS.XLARGE),
    createNumberField('display_order', 'Display Order', FIELD_WIDTHS.SMALL),
    createSelectField('priority', 'Priority', [...PRIORITY_OPTIONS], FIELD_WIDTHS.SMALL),
    createDateField('start_date', 'Start Date', FIELD_WIDTHS.MEDIUM),
    createDateField('target_end_date', 'Target End Date', FIELD_WIDTHS.MEDIUM),
    createJsonField('metadata', 'Metadata', FIELD_WIDTHS.XLARGE),
    ...createAccountTrackingFields({ includeArchived: true }),
    createArchivedAtField(),
    createCreatedAtField(),
    createUpdatedAtField(),
    createDeletedAtField(),
  ],
});

export const projectCache = getCache('project');
